'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var Contact = function Contact() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Contact us | Doctify',
				pageDescription: 'Contact Doctify and we will help you with your enquiry. Rate, review and book doctors and specialists online',
				pagePath: (0, _doctifyUtils.getResourcePath)('/content')
			},
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h1',
					null,
					'Contact Doctify'
				),
				_react2.default.createElement(
					'p',
					null,
					'Please get in touch if there is anything we can help with and we will do our best to support you! Your enquiry is important to us.'
				),
				_react2.default.createElement(
					'ul',
					null,
					_react2.default.createElement(
						'li',
						null,
						'Call us at ',
						_constants.DOCTIFY_PHONE
					),
					_react2.default.createElement(
						'li',
						null,
						_constants.DOCTIFY_ADDRESS_SINGLE_LINE
					),
					_react2.default.createElement(
						'li',
						null,
						'Email us at ',
						_react2.default.createElement(
							'a',
							{ href: 'mailto:' + _constants.DOCTIFY_HELLO_EMAIL },
							_constants.DOCTIFY_HELLO_EMAIL
						)
					),
					_react2.default.createElement(
						'li',
						null,
						'Tweet us at ',
						_react2.default.createElement(
							'a',
							{ href: 'https://twitter.com/doctifyuk' },
							'doctifyuk'
						)
					)
				),
				_react2.default.createElement(
					'p',
					null,
					'You can also follow or contact us through social media.'
				)
			)
		)
	);
};

Contact.displayName = 'Contact';

Contact.defaultProps = {};

exports.default = Contact;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/contact-page.js